// const THEME = ["#ff2999", "#005cff"];
// console.log(" THEME", THEME);

const styles = (color, bg) =>
  [
    `color: ${color || "black"}`,
    `background: ${bg || "white"}`,
    "font-size: 15px",
    "padding: 2px",
  ].join(";");

const Log = Object.freeze({
  i: (...message) => console.info(...message), // console.info("%c[INFO]", styles(THEME[1]), ...message),
  e: (...message) => console.error(...message), // console.error("%c[ERROR]", styles(undefined, "red"), ...message),
  w: (...message) => console.warn(...message), // console.warn("%c[WARN]", styles("black", "#fe8d59"), ...message),
  d: (...message) => {
    const env = process.env.NODE_ENV || localStorage.getItem("MEETPOPPINS_ENV");
    if (env === "development")
      console.log("%c[DEBUG]", styles("black", "yellow"), ...message);
    else console.log("Debug logs are disabled");
  },

  l: (...message) => console.log(...message), // console.log("%c[LOG]", styles("black"), ...message),
  t: (...message) => console.trace(...message),
});

export default Log;
